module.exports = __webpack_public_path__ + "static/media/GHZ.9fdf0bc3.jpg";